import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import { Shield, Users, Lock, Clock, Database, Mail, AlertCircle, CheckCircle2, Eye, FileText } from 'lucide-react';

const PolitiqueRGPDPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navigation />
      
      {/* Bouton Retour */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/" label="Retour à l'accueil" />
      </div>

      <div className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-600 rounded-full mb-4">
              <Shield className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-indigo-900 mb-2">
              Politique de Confidentialité & RGPD
            </h1>
            <p className="text-gray-600">SCIC SAS OBJECTIF SCOP OUTREMER</p>
            <p className="text-sm text-gray-500 mt-2">Conforme au RGPD (2016/679) et à la Loi Informatique et Libertés</p>
          </div>
          
          <Card className="shadow-xl">
            <CardContent className="p-4 md:p-8">
              <div className="prose prose-lg max-w-none">
                
                {/* Introduction */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <div className="bg-indigo-50 p-6 rounded-lg border-l-4 border-indigo-600">
                    <p className="text-sm leading-relaxed text-gray-700">
                      Conformément au Règlement Général sur la Protection des Données (RGPD – 2016/679) et à la Loi Informatique et Libertés modifiée, 
                      <strong className="text-indigo-900"> la SCIC SAS OBJECTIF SCOP OUTREMER</strong> assure la protection et la confidentialité 
                      des données personnelles collectées via ce site.
                    </p>
                  </div>
                </div>

                {/* Section 1 - Responsable du traitement */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Users className="h-6 w-6 text-amber-500" />
                    1. RESPONSABLE DU TRAITEMENT
                  </h2>
                  <p className="mb-3">Le responsable du traitement des données personnelles collectées via ce site est :</p>
                  
                  <div className="bg-indigo-50 p-6 rounded-lg border-l-4 border-indigo-600 mb-4">
                    <p className="font-semibold text-indigo-900 mb-3">SCIC SAS OBJECTIF SCOP OUTREMER</p>
                    <ul className="space-y-2 text-sm">
                      <li><strong>Forme juridique :</strong> Société Coopérative d'Intérêt Collectif – SAS à capital variable</li>
                      <li><strong>SIREN :</strong> 903 459 139</li>
                      <li><strong>Siège social :</strong> 13 rue Rodrigue YOUYOUTE, 97139 Les Abymes – Guadeloupe (France)</li>
                      <li><strong>Représentée par :</strong> Madame Félixia Vanessa PIPEROL, Présidente</li>
                    </ul>
                    
                    <div className="mt-4 pt-4 border-t border-indigo-200">
                      <p className="font-semibold text-indigo-900 mb-2">Contact DPO (Délégué à la Protection des Données) :</p>
                      <div className="flex items-center gap-2">
                        <Mail className="h-4 w-4 text-amber-500" />
                        <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">
                          dpo@objectifscopoutremer.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section 2 - Finalités */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <FileText className="h-6 w-6 text-amber-500" />
                    2. FINALITÉS DES TRAITEMENTS
                  </h2>
                  <p className="mb-4">Les données personnelles collectées via le site sont utilisées pour les finalités suivantes :</p>
                  
                  <div className="space-y-3">
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Gestion des comptes utilisateurs (membres, conseillers, experts)</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Accès aux services coopératifs et espaces réservés</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Mise en relation avec les établissements et partenaires ESS</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Gestion des demandes d'accompagnement et de formation</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Groupement d'employeurs et services coopératifs</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Amélioration de la navigation et des services</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg border-l-2 border-blue-400">
                      <p className="text-sm">✓ Communication des actualités et événements ESS</p>
                    </div>
                  </div>

                  <div className="mt-4 p-4 bg-green-50 border-l-4 border-green-500 rounded">
                    <p className="text-sm font-medium text-green-900 flex items-center gap-2">
                      <CheckCircle2 className="h-5 w-5" />
                      Aucune donnée n'est vendue ni cédée à des fins commerciales.
                    </p>
                  </div>
                </div>

                {/* Section 3 - Base légale */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    3. BASE LÉGALE DES TRAITEMENTS
                  </h2>
                  <p className="mb-3">Les traitements de données personnelles sont fondés sur :</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 font-bold mt-1">•</span>
                      <span><strong>L'exécution du contrat</strong> ou de l'adhésion coopérative</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 font-bold mt-1">•</span>
                      <span><strong>Le consentement</strong> de l'utilisateur (formulaires, inscriptions)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 font-bold mt-1">•</span>
                      <span><strong>L'intérêt légitime</strong> de la SCIC OSO dans le cadre de ses missions ESS</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 font-bold mt-1">•</span>
                      <span><strong>Les obligations légales</strong> applicables</span>
                    </li>
                  </ul>
                </div>

                {/* Section 4 - Durée de conservation */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Clock className="h-6 w-6 text-amber-500" />
                    4. DURÉE DE CONSERVATION
                  </h2>
                  <div className="bg-gray-50 p-5 rounded-lg">
                    <p className="mb-3">Les données personnelles sont conservées pour une durée <strong>strictement nécessaire</strong> aux finalités décrites, et conformément aux obligations légales :</p>
                    <ul className="space-y-2 text-sm ml-4">
                      <li>• Comptes utilisateurs actifs : durée de l'adhésion + 3 ans</li>
                      <li>• Comptes inactifs : suppression après 3 ans sans connexion</li>
                      <li>• Données comptables et fiscales : 10 ans</li>
                      <li>• Données de prospection : 3 ans après dernier contact</li>
                    </ul>
                  </div>
                </div>

                {/* Section 5 - Vos droits */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Shield className="h-6 w-6 text-amber-500" />
                    5. VOS DROITS (RGPD)
                  </h2>
                  <p className="mb-4">En application du RGPD, chaque utilisateur dispose des droits suivants :</p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2 flex items-center gap-2">
                        <Eye className="h-4 w-4" />
                        Droit d'accès
                      </h3>
                      <p className="text-sm text-gray-700">Obtenir une copie de vos données personnelles</p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2">📝 Droit de rectification</h3>
                      <p className="text-sm text-gray-700">Corriger vos données inexactes ou incomplètes</p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2">🗑️ Droit à l'effacement</h3>
                      <p className="text-sm text-gray-700">Supprimer vos données (sous conditions)</p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2">⏸️ Droit à la limitation</h3>
                      <p className="text-sm text-gray-700">Limiter le traitement de vos données</p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2">🚫 Droit d'opposition</h3>
                      <p className="text-sm text-gray-700">Vous opposer au traitement de vos données</p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-indigo-900 mb-2">📦 Droit à la portabilité</h3>
                      <p className="text-sm text-gray-700">Récupérer vos données dans un format structuré</p>
                    </div>
                  </div>

                  <div className="bg-amber-50 p-5 rounded-lg border-l-4 border-amber-500">
                    <h3 className="font-semibold text-amber-900 mb-2">Comment exercer vos droits ?</h3>
                    <p className="text-sm mb-3">Pour exercer l'un de ces droits, contactez notre DPO :</p>
                    <div className="flex items-center gap-2 mb-2">
                      <Mail className="h-5 w-5 text-amber-600" />
                      <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-600 font-medium">
                        dpo@objectifscopoutremer.com
                      </a>
                    </div>
                    <p className="text-xs text-gray-600 mt-3">
                      Votre demande sera traitée dans un délai maximum d'<strong>1 mois</strong>. 
                      Une pièce d'identité pourra être demandée pour vérifier votre identité.
                    </p>
                  </div>
                </div>

                {/* Section 6 - Destinataires */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Users className="h-6 w-6 text-amber-500" />
                    6. DESTINATAIRES DES DONNÉES
                  </h2>
                  <p className="mb-4">Les données personnelles peuvent être transmises uniquement aux destinataires suivants :</p>
                  
                  <div className="space-y-3">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-semibold text-gray-900 mb-2">Services internes OSO</p>
                      <p className="text-sm text-gray-600">Équipes habilitées dans le cadre de leurs missions</p>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-semibold text-gray-900 mb-2">Établissements secondaires du réseau</p>
                      <p className="text-sm text-gray-600">Dans le cadre coopératif ESS</p>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-semibold text-gray-900 mb-2">Prestataires techniques</p>
                      <p className="text-sm text-gray-600">Hébergement, maintenance (sous engagement de confidentialité)</p>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-semibold text-gray-900 mb-2">Autorités compétentes</p>
                      <p className="text-sm text-gray-600">Sur demande légale uniquement</p>
                    </div>
                  </div>

                  <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded">
                    <p className="text-sm text-blue-900">
                      <strong>Sous-traitants et transferts :</strong> Selon les fonctionnalités utilisées, OSO peut recourir à Emergent Labs Inc. (hébergement et infrastructure), PostHog (mesure d’audience après consentement), Stripe (paiement), Brevo (communications) et Cloudflare (sécurité et diffusion). Certains prestataires sont établis ou peuvent traiter des données hors de l’Espace économique européen. Ces transferts sont encadrés par les mécanismes prévus au chapitre V du RGPD, notamment les décisions d’adéquation ou les clauses contractuelles types applicables.
                    </p>
                  </div>
                </div>

                {/* Section 7 - Sécurité */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Lock className="h-6 w-6 text-amber-500" />
                    7. SÉCURITÉ DES DONNÉES
                  </h2>
                  <p className="mb-4">OSO met en œuvre toutes les mesures techniques et organisationnelles appropriées pour assurer la sécurité de vos données :</p>
                  
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold mt-1">✓</span>
                      <span>Chiffrement HTTPS pour toutes les communications</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold mt-1">✓</span>
                      <span>Authentification sécurisée (mots de passe hashés)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold mt-1">✓</span>
                      <span>Sauvegardes régulières des données</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold mt-1">✓</span>
                      <span>Accès restreint et journalisé aux données</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 font-bold mt-1">✓</span>
                      <span>Sensibilisation du personnel à la protection des données</span>
                    </li>
                  </ul>
                </div>

                {/* Section 8 - Cookies */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Database className="h-6 w-6 text-amber-500" />
                    8. COOKIES
                  </h2>
                  <p className="mb-4">Le site utilise des cookies et autres traceurs. Les traceurs non strictement nécessaires, notamment la mesure d’audience PostHog, ne sont activés qu’après votre consentement.</p>
                  
                  <div className="bg-gray-50 p-5 rounded-lg mb-4">
                    <p className="font-semibold mb-3">Types de cookies utilisés :</p>
                    <ul className="space-y-2 text-sm">
                      <li><strong>Cookies techniques :</strong> Indispensables au fonctionnement du site (sessions, authentification)</li>
                      <li><strong>Cookies de mesure d'audience :</strong> Analyse des statistiques de visite (anonymisées)</li>
                      <li><strong>Cookies fonctionnels :</strong> Préférences utilisateur, langue, etc.</li>
                    </ul>
                  </div>

                  <div className="bg-indigo-50 p-4 rounded border-l-4 border-indigo-600">
                    <p className="text-sm">
                      <strong>Gestion des cookies :</strong> Vous pouvez accepter ou refuser les traceurs non essentiels avec le bandeau prévu à cet effet, puis retirer ou modifier votre choix à tout moment grâce au bouton permanent « Gérer les cookies ». Vous pouvez également configurer votre navigateur.
                    </p>
                  </div>
                </div>

                {/* Section 9 - Réclamation */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <AlertCircle className="h-6 w-6 text-amber-500" />
                    9. DROIT DE RÉCLAMATION
                  </h2>
                  <div className="bg-orange-50 p-5 rounded-lg border-l-4 border-orange-500">
                    <p className="mb-3">Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL :</p>
                    <div className="text-sm space-y-2">
                      <p><strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong></p>
                      <p>3 Place de Fontenoy – TSA 80715 – 75334 Paris Cedex 07</p>
                      <p>Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-amber-500 font-medium">www.cnil.fr</a></p>
                    </div>
                  </div>
                </div>

                {/* Section 10 - Contact */}
                <div className="mb-4">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    10. CONTACT
                  </h2>
                  <div className="bg-indigo-50 p-6 rounded-lg border-l-4 border-indigo-600">
                    <p className="font-semibold text-indigo-900 mb-4">Pour toute question relative à la protection de vos données personnelles :</p>
                    
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <Mail className="h-5 w-5 text-amber-500 mt-1 flex-shrink-0" />
                        <div>
                          <p className="font-medium text-gray-900">Email DPO :</p>
                          <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">
                            dpo@objectifscopoutremer.com
                          </a>
                        </div>
                      </div>
                      
                      <div className="flex items-start gap-3">
                        <Mail className="h-5 w-5 text-amber-500 mt-1 flex-shrink-0" />
                        <div>
                          <p className="font-medium text-gray-900">Email général :</p>
                          <a href="mailto:contact@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">
                            contact@objectifscopoutremer.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Date de mise à jour */}
                <div className="mt-8 pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-500 text-center">
                    <strong>Dernière mise à jour :</strong> Septembre 2026
                  </p>
                </div>

              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PolitiqueRGPDPage;
